module.exports = __webpack_public_path__ + "static/img/employee-04-big.e11b4f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/employee-04-big.png
// module id = G5GW
// module chunks = 2